import React from 'react';
import mobileEPLogo from '../img/exampro-logo-white.svg';

/**
 * MobileHeader functional component.
 * Renders the mobile navigation header with a sidebar toggle button, logo, title, and student name.
 *
 * @param {Object} props - React props.
 * @param {Function} props.sidebartoggle - Function to toggle the sidebar.
 * @param {Object} props.student - Student object containing user details.
 * @returns {JSX.Element} The mobile header element.
 */
function MobileHeader(props) {
    return (
        <div className='mobile-nav'>
            <button className="sidebar-toggle" onClick={() => props.sidebartoggle()}><i className="fas fa-bars"></i></button>
            <img className="mobile-logo" src={mobileEPLogo} alt="brand-logo" />
            <h2 className="mobile-header">Student portal</h2>
            <p className="mobile-name">{props.student.fullname}</p>
        </div>
    );
}

export default MobileHeader;